import { KIND } from 'baseui/button'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import {
  addAddressButtonOverrides,
  pulseAddAddressButtonOverrides,
} from '@/containers/SubscriptionFormPageNew/Components/Address/styled-components'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'

const useAddAddressButton = () => {
  const { t, addressesList, updateActiveAddressHandler } = useAddress()
  const isPulse = usePulseScope()

  return {
    t,
    hidden: !addressesList.length,
    isPulse,
    buttonKind: isPulse ? KIND.secondary : undefined,
    buttonOverrides: isPulse ? pulseAddAddressButtonOverrides : addAddressButtonOverrides,
    onAddAddress: () => updateActiveAddressHandler('new'),
  }
}

export default useAddAddressButton
